import { ArgumentException } from '../errors';
import { throwIfEmptyOrWhitespacePropertyExists } from '../validation/validation';
import { FullView } from '../views/fullView';
import { TagView } from '../views/tagView';
/** @inheritdoc */
export class ViewableClient {
    /**
     * The default constructor.
     * @param dataStore: An implementation of Mfs DataStore interface
     */
    constructor(dataStore) {
        this.dataStore = dataStore;
    }
    /** @inheritdoc */
    viewBy(viewKind, criteria) {
        if (!criteria) {
            throw new ArgumentException(`View criteria must be defined.`);
        }
        throwIfEmptyOrWhitespacePropertyExists(criteria, 'cardId');
        switch (viewKind) {
            case 'fullView':
                return new FullView(this.dataStore).retrieve(criteria);
            case 'tagView':
                return new TagView(this.dataStore).retrieve(criteria);
            default: {
                throw new ArgumentException(`Unable to determine ViewKind of ${viewKind}`);
            }
        }
    }
}
//# sourceMappingURL=viewableClient.js.map